import PropTypes from 'prop-types';
import React from 'react';
import cls from 'classnames';
import iconErr from 'assets/icons/error.svg';
import iconSuccess from 'assets/icons/checked.svg';
import { iconInfo2 } from 'assets/icons';

export const STATUS = {
	err: 'error',
	success: 'success',
	info: 'info',
};

export default function Notify(props) {
	const { content, className, type } = props;

	const getIconNoti = () => {
		if (type === STATUS.err) {
			return iconErr;
		} else if (type === STATUS.success) {
			return iconSuccess;
		} else if (type === STATUS.info) {
			return iconInfo2;
		}
	};

	return (
		<div
			className={cls({
				'border rounded-4px pt-13px pr-16px pb-23px pl-17px flex items-start': true,
				[`${className}`]: className,
				'border-F7ADB2 bg-FFECEF': type === STATUS.err,
				'border-8FDFC6 bg-E9FCEC': type === STATUS.success,
				'border-0090F0 bg-EDF7FF': type === STATUS.info,
			})}
		>
			<div className='w-32px h-32px bg-F7ADB2 rounded-full'>
				<img src={getIconNoti()} width={32} height={32} alt='' />
			</div>
			<div className='ml-12px text-14px flex-1'>{content}</div>
		</div>
	);
}

Notify.propTypes = {
	content: PropTypes.node,
	type: PropTypes.oneOf([STATUS.err, STATUS.success]),
};
